// Shared added/removed/changed/unchanged color, used for node/edge group
// headers and the per-row status border so the two stay visually tied together.
export const STATUS_COLOR = { added: '#22c55e', removed: '#ef4444', changed: '#f59e0b', unchanged: '#94a3b8' };
